import React from "react";

const NotificationBadge = ({
  top = null,
  right = null,
  bottom = null,
  left = null,
  width = "24px",
  height = "24px",
  numberNotifications,
  color = "red",
  position = "absolute",
}) => {
  if (numberNotifications <= 0) return null;

  const style = {
    position: position,
    top: top ?? null,
    right: right ?? null,
    bottom: bottom ?? null,
    left: left ?? null,
    backgroundColor: color,
    color: "white",
    borderRadius: "50%",
    width,
    height,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "bold",
    boxShadow: "0 0 6px rgba(0,0,0,0.3)",
  };

  return <div style={style}>{numberNotifications}</div>;
};

export default NotificationBadge;
